/*
 * @Author: etong
 * @Date: 2021-11-23 16:30:32
 * @LastEditTime: 2023-10-11 18:07:29
 * @LastEditors: your name
 * @Description:
 * @FilePath: \oak\src\api\login.js
 * Think first, Program later
 */
import request from '@/utils/request'

// 登录
export function Login(data) {
  return request({
    url: 'SupplierLogin/Login',
    method: 'post',
    data: data
  })
}

// 获取路由信息
export function GetFunction(data) {
  return request({
    url: 'SupplierLogin/GetFunction',
    method: 'get',
    params: { supplier_flag: '2' }
  })
}

// 更改密码GET /api/SupplierLogin/ChangePassword
export function ChangePassword(data) {
  return request({
    url: 'SupplierLogin/ChangePassword',
    method: 'get',
    params: data
  })
}
export function loginByUsername(username, password) {
  const data = {
    username,
    password
  }
  return request({
    url: '/login/login',
    method: 'post',
    data
  })
}

export function logout() {
  return request({
    url: '/login/logout',
    method: 'post'
  })
}

export function getUserInfo(token) {
  return request({
    url: '/user/info',
    method: 'get',
    params: { token }
  })
}

// 查询api地址列表
export function GetDebugAddressList(data) {
  return request({
    url: 'ListFieldConf/GetDebugAddressList',
    method: 'get',
    params: data
  })
}
// 保存
export function AddDebugAddress(data) {
  return request({
    url: 'ListFieldConf/AddDebugAddress',
    method: 'post',
    data: data
  })
}
// 删除
export function DelDebugAddress(data) {
  return request({
    url: 'ListFieldConf/DelDebugAddress',
    method: 'post',
    data: data
  })
}

// 人机验证
export function RobotValidate(data) {
  return request({
    url: 'SupplierLogin/RobotValidate',
    method: 'post',
    data: data
  })
}

// 人机验证后登陆
export function LoginV1(data) {
  return request({
    url: 'SupplierLogin/LoginV1',
    method: 'post',
    data: data
  })
}
